import {Component, Input} from "@angular/core";
import {Member} from "../../../service/member/member";
import {AuthService} from "../../../service/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberPost} from "../../../service/member-post/member-post";
import {MemberPostService} from "../../../service/member-post/member-post.service";
import {GtmService} from "../../../service/gtm/gtm.service";
import {DatePipe} from "@angular/common";
import {QuillConfigService} from "../../../service/quill/quill.service";
import {ImageUploadService} from "../../../service/image/image.service";
import { ShareService } from "app/service/share/share.service";

@Component({
  selector: 'app-member-detail',
  templateUrl: 'member-detail.component.html',
  styleUrls: ['member-detail.component.scss'],
  providers: [ShareService, MemberPostService, AuthService, DatePipe, QuillConfigService, ImageUploadService]
})
export class MemberDetailComponent{
  post: MemberPost;
  id: number;
  updating: boolean = false;
  me: Member;

  constructor(private shareService: ShareService,
              private postService: MemberPostService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
              private quillService: QuillConfigService,
              private imageService: ImageUploadService,
              private gtmService: GtmService,
              private datePipe: DatePipe) {
    this.shareService.awaitMe().subscribe(
      me => {
        this.me = me;
        this.init();
      }
    );
  }

  init() {
    this.route.params.subscribe(params => {
      this.id = params['id'] ? +params['id'] : null;

      if (this.id) {
        this.postService.getPost(this.id).subscribe(post => {
          this.updating = false;
          this.post = post;
          this.email = post.email;

          this.gtmService.pageViewWithPage({
            'path': this.route.snapshot['_routerState'].url,
            'title': post.title,
            'breadcrumb': 'Home > Member > 멤버 소개'
          });
        });
      } else {
        this.updating = true;
        this.post = new MemberPost();
        this.post.location = {
          key: this.me.location.key
        }

        this.gtmService.pageViewWithPage({
          'path': this.route.snapshot['_routerState'].url,
          'title': '글쓰기',
          'breadcrumb': 'Home > Member > 멤버 소개'
        });
      }
    });
  }

  onCanUpdate(): boolean {
    return !this.updating && !!this.post && (
      (this.post.author.team.id == this.me.team.id && this.authService.isManager()) 
      || this.authService.isAdmin()
    );
  }
  onClickUpdate() {
    window.scrollTo(0, 0);
    this.updating = true;
  }
  onClickBack() {
    window.scrollTo(0, 0);
    this.updating = false;
  }
  onDelete() {
    if (window.confirm('삭제 하시겠습니까?')) {
      this.postService.delete(this.id).subscribe(
        post => this.router.navigateByUrl('/member/search')
      );
    }
  }

  onUpdate(post: MemberPost) {
    if(this.id) post.id = this.id;
    post.email = this.email;

    if (!post.title) {
      window.alert('제목을 입력해 주세요.');
      return;
    } else if (!post.thumbnail) {
      window.alert('썸네일을 등록해 주세요.');
      return;
    } else if (!post.summary) {
      window.alert('요약을 입력해 주세요.');
      return;
    } else if (!post.content) {
      window.alert('내용을 입력해 주세요.');
      return;
    }

    if (post.id) {
      post = {...this.post, ...post};

      this.postService.update(post).subscribe(
        post => {
          window.alert('게시물이 수정되었습니다.');

          this.updating = false;
          this.post = post;

          window.scrollTo(0, 0);
        }
      );
    } else {
      post = {...this.post, ...post};

      this.postService.create(post).subscribe(
        post => {
          window.alert('게시물이 등록되었습니다.');

          this.updating = false;
          this.post = {...this.post, ...post};

          this.gtmService.newPostEvent({
            'title': post.title,
            'list': 'Members',
            'date': this.datePipe.transform(post.createdDate, 'yyyyMMdd'),
            'author': post.author.nick || post.author.name
          });
          this.router.navigateByUrl(`/member/search/${post.id}`);
        }
      );
    }
  }

  onNumberCheck(phone: string) {
    return phone.replace(/[^0-9\.]+/g, '');
  }

  private _email;
  private email_provider = [
    '@naver.com',
    '@gmail.com',
    '@hanmail.com',
    '@Hotmail.com',
    '@nate.com',
    '@yahoo.com',
  ]
  email_list: string[] = []
  get email(): string { return this._email; }
  @Input()
  set email(val: string) {
    this._email = val ? val : '';
    if(this._email.length && this._email.split('@').length === 1) {
      this.email_list = this.email_provider.map(o => val+o)
    } else {
      this.email_list = []
    }
  }
  onClickEmailItem(item){
    this.email = item;
  }

  public editor;
  onEditorCreated(quill) {
    this.editor = quill;

    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('image', this.imageHandler.bind(this));
  }

  imageHandler() {
    const Imageinput = document.createElement('input');
    Imageinput.setAttribute('type', 'file');
    Imageinput.setAttribute('accept', 'image/png, image/gif, image/jpeg');
    Imageinput.classList.add('ql-image');

    Imageinput.addEventListener('change', () =>  {
      const file = Imageinput.files;
      this.imageService.makeFileRequest('/api/file-uploads', file).then(
        (result) => {
          this.pushImageToEditor(result['filename']);
        },
      )
    });

    Imageinput.click();
  }
  pasteHandler(imageDataUrl, type, imageData) {
    const file = imageData.toFile('paste.png')
    this.imageService.makeFileRequest('/api/file-uploads', [file]).then(
      (result) => {
        this.pushImageToEditor(result['filename']);
      },
    )
  }
  get pasteImageHandler() {
    return this.pasteHandler.bind(this)
  }
  pushImageToEditor(src) {
    const range = this.editor.getSelection(true);
    const index = range.index + range.length;
    this.editor.insertEmbed(range.index, 'image', src);
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-board/member-detail/member-detail.component.ts